import _ from 'lodash'

export default function getAdditionalReplacements() {
  const user = JSON.parse(localStorage.getItem('ngStorage-user'))
  if (!user) return {}

  /** All user phone numbers
   * @type {{ phoneNum: string; phoneTypeId: number; revisionHash: string; [key: string]: Record<string, any> }[]}
   */
  const allPhoneNumbers = _.get(user, 'address.phones')

  return {
    userName: user.fullName,
    currentPosition: user.currentPosition,
    userPosition: user.currentPosition.positionDescription,
    positionDescription: user.currentPosition.positionDescription,
    userEmail: user.email,
    phone: user.address.phones?.map(phone => phone.phoneNum).join(', '),
    phoneNum: user.address.phones[0]?.phoneNum,
    phoneNumbers: _.map(_.filter(allPhoneNumbers, val => val.phoneTypeId !== 3), 'phoneNum'),
    mobileNumbers: _.map(_.filter(allPhoneNumbers, { phoneTypeId: 3 }), 'phoneNum')
  }
}
